import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import './BusinessMembership.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import { Link } from 'react-router-dom';

const BusinessMembership = () => {

    useEffect(() => {
        document.title = `Business Membership | Local Bells`;
        document.getElementById('bodywrap').className = 'busimembership';
    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible}/>
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>                                
                                <Row>
                                    <Col>
                                        <h3 className='mem-head'>Membership</h3>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Row>
                                            <Col md={6} lg={6} xl={6} xxl={4}>
                                                <div className='yp-box'>
                                                    <Row>
                                                        <Col>
                                                            <p className='yp-id'>Business id : #s5d4fs5af</p>
                                                            <h6 className='yp-plan'>Premium membership</h6>                                                        
                                                        </Col>
                                                        <Col className='yp-date-box'>
                                                            <h6 className='yp-date'>Renew Date : <span className='fw-500'>05/06/2025</span></h6>
                                                        </Col>
                                                    </Row>                                                    
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className='mb-5'>
                                    <Col md="6" lg={6} xl={6} xxl={4}>
                                        <div className='reg-plan'>
                                            <div className='reg-plan-top'>
                                                <h4>Regular</h4>
                                                <h6>Free/Year</h6>
                                            </div>
                                            <div className='reg-plan-bot'>
                                                <div>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/tick.webp'} className="img-fluid" alt="tick" />
                                                    <h6>Up to 5 active product Listing.</h6>
                                                </div>
                                                <div>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/tick.webp'} className="img-fluid" alt="tick" />
                                                    <h6>Rs.500 bonus for business promotion</h6>
                                                </div>
                                                <div>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/tick.webp'} className="img-fluid" alt="tick" />
                                                    <h6>Product listing support via WhatsApp</h6>
                                                </div>
                                                <div>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/tick.webp'} className="img-fluid" alt="tick" />
                                                    <h6>Free Online Business Page</h6>
                                                </div>   
                                                <Link to="" className='sel-link'>select</Link>                                                                                                                                             
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md="6" lg={6} xl={6} xxl={4}>
                                        <div className='premium-plan'>
                                            <div className='premium-plan-top'>
                                                <h4>Premium</h4>
                                                <h6><strike>Rs-5999/Year</strike> <span className='fw-500 ms-2'>Rs 2999/Year</span></h6>
                                            </div>
                                            <div className='premium-plan-bot'>
                                                <div>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/tick.webp'} className="img-fluid" alt="tick" />
                                                    <h6>All Features of Regular Membership</h6>
                                                </div>
                                                <div>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/tick.webp'} className="img-fluid" alt="tick" />
                                                    <h6>Unlimited Product Listing</h6>
                                                </div>
                                                <div>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/tick.webp'} className="img-fluid" alt="tick" />
                                                    <h6>Professional Product Listing Support</h6>
                                                </div>
                                                <div>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/tick.webp'} className="img-fluid" alt="tick" />
                                                    <h6>Rs.3000 bonus for business promotion</h6>
                                                </div> 
                                                <div>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/tick.webp'} className="img-fluid" alt="tick" />
                                                    <h6>Online Search Optimized for business (SEO) for business page</h6>
                                                </div>
                                                <div>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/tick.webp'} className="img-fluid" alt="tick" />
                                                    <h6>Proffered WhatsApp support</h6>
                                                </div>                                                   
                                                <div to="" className='cam-link'>Current active membership</div>                                                                                                                                             
                                            </div>
                                        </div>
                                    </Col>                                    
                                </Row>
                                <div className='footer-org footer'>
                                    <Footer />                                
                                </div>    
                                
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default BusinessMembership;


